module.exports = __webpack_public_path__ + "static/media/habbit-logo2.010f541c.png";